'use strict'
// this exists so we can replace it during testing
module.exports = process



//////////////////
// WEBPACK FOOTER
// ./~/fsevents/~/gauge/process.js
// module id = 1381
// module chunks = 0